<script setup lang="ts" name="TimelineChart">
import { onMounted, ref, useTemplateRef } from 'vue';

import type { ITimelineChartMonthDates } from '~/types';

defineProps<{
  monthDates: ITimelineChartMonthDates[];
  columnWidth: number | null;
}>();
const containerRef = useTemplateRef<HTMLElement>('containerRef');

onMounted(async () => {
  const todayEl = containerRef.value?.querySelector('#today');
  if (todayEl) {
    (todayEl as HTMLElement).scrollIntoView({
      inline: 'center',
    });
  }
});
</script>

<template>
  <div
    ref="containerRef"
    class="grid"
    :style="{
      gridTemplateColumns: `repeat(${monthDates.length}, minmax(max-content, 1fr))`,
    }"
  >
    <div
      v-for="(monthDate, index) in monthDates"
      :key="monthDate.month"
      :class="{
        'bg-charcoal-2': index % 2 === 0,
        'bg-charcoal-3': index % 2 !== 0,
      }"
      data-testid="month"
    >
      <div
        class="truncate pt-5 text-center text-overline font-bold text-charcoal-9"
      >
        {{ monthDate.month }}
      </div>
      <div class="flex" data-testid="dates">
        <div
          v-for="{ day, isToday } in monthDate.monthDays"
          :key="day"
          class="flex justify-center pb-5 text-center"
          :style="{
            width: `${columnWidth}px`,
          }"
        >
          <p
            :id="isToday ? 'today' : null"
            class="mx-2 w-full p-1"
            :class="{ 'rounded-md bg-ocean-6 text-white': isToday }"
          >
            {{ day }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
